/**
 * The accent colour a vertical paints the app with.
 *
 * `vertical_registry.ui_tokens.primary_accent` is injected as `--fd-accent-raw` (each theme shades it into `--fds-accent`) at
 * runtime (useMoldedUI). The mechanic row still carries the old Forge amber,
 * and browsers hold it in cached manifests too, so without this the 2026-10
 * Midnight & Ivory retheme would be painted back to amber the moment a trader
 * signed in. Accents that were only ever the *brand default* resolve to the
 * current brand gold; a vertical that chose any other colour keeps it.
 *
 * Keep the retired values literal here. A colour sweep that "modernises" this
 * set to the new gold turns the rule into a no-op — brandAccent.test.ts fails
 * if that happens.
 */
export const BRAND_ACCENT = '#BDA46A';

/**
 * The colour a trader's documents (invoices, quotes, reports, the payment
 * pages a customer sees) use when the trader has not chosen one. It is DATA,
 * not theme: it is stamped into PDFs and shown to customers, so it is a
 * literal and the same in every app theme. Documents used to fall back to
 * three different greens depending on which file built them.
 */
export const DEFAULT_DOCUMENT_ACCENT = '#7fc29d';

const RETIRED_BRAND_ACCENTS = new Set([
    '#d4900a', // Forge amber, v2 (2026-05)
    '#e9a015', // its hover step
]);

export function resolveAccent(raw: string | null | undefined): string {
    const value = (raw ?? '').trim();
    if (!value || RETIRED_BRAND_ACCENTS.has(value.toLowerCase())) return BRAND_ACCENT;
    return value;
}
